import type { Ref } from 'vue';
import { ref } from 'vue';
import { defineStore } from 'pinia';
import type { Participant } from '@getaccept/dsr-shared-new';
import { ParticipantRole } from '@getaccept/lib-shared-new/src/dealroom/types/enums/participant-role';
import { ParticipantHelper } from '@getaccept/dsr-shared-new/src/helpers/participant.helper';
import { DsrService } from '../../api/dsr/service/dsr.service';

export const useParticipantsStore = defineStore('participants', () => {
  const participants: Ref<Participant[]> = ref([]);
  const senders: Ref<Participant[]> = ref([]);
  const owner: Ref<Participant> = ref(null);
  const universalLink = ref('');

  const loadParticipants = async () => {
    try {
      const loadedParticipants = await DsrService.loadParticipants();

      participants.value = [];
      senders.value = [];

      loadedParticipants.forEach(participant => {
        const formattedParticipant = ParticipantHelper.formatParticipant(participant);
        participant.role === ParticipantRole.Viewer
          ? participants.value.push(formattedParticipant)
          : senders.value.push(formattedParticipant);
      });
      setOwner();
    } catch (e) {
      participants.value = [];
      senders.value = [];
    }
  };

  const setOwner = () => {
    owner.value = senders.value.find(sender => sender.role === ParticipantRole.Owner);
  };

  const loadUniversalLink = async () => {
    try {
      universalLink.value = await DsrService.loadUniversalLink();
    } catch {
      universalLink.value = '';
    }
  };

  const reset = () => {
    participants.value = [];
    senders.value = [];
    owner.value = null;
    universalLink.value = '';
  };

  return {
    owner,
    reset,
    setOwner,
    participants,
    senders,
    loadUniversalLink,
    universalLink,
    loadParticipants,
  };
});
